import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/terms/page.tsx");
